import { useContext } from 'react';
import { Card, StyledFlex, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { StyledHeaderText } from 'src/features/module/components/module.styles';
import { ThemeColorMode } from 'src/common/enums';
import ModuleTreeDiagramDark from 'src/images/pngs/module/module-tree-diagram-dark.png';
import ModuleTreeDiagramLight from 'src/images/pngs/module/module-tree-diagram-light.png';
import { StyledImage } from './what-are-modules.styles';
export const WhatAreModules: React.FC = () => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDark = theme === ThemeColorMode.DARK;
  const moduleTreeDiagram = isDark ? ModuleTreeDiagramDark : ModuleTreeDiagramLight;
  return <Card data-sentry-element="Card" data-sentry-component="WhatAreModules" data-sentry-source-file="what-are-modules.tsx">
      <StyledFlex flexDirection="column" alignItems="flex-start" gap="2.4rem" data-sentry-element="StyledFlex" data-sentry-source-file="what-are-modules.tsx">
        <StyledHeaderText data-sentry-element="StyledHeaderText" data-sentry-source-file="what-are-modules.tsx">What are modules?</StyledHeaderText>
        <div>
          <p>
            A learning pathway is made up of modules, and a module is made of bite-sized rooms &#40;think of a room like
            a mini security lab&#41;.
          </p>
          <StyledImage src={moduleTreeDiagram} alt="Module tree diagram" data-sentry-element="StyledImage" data-sentry-source-file="what-are-modules.tsx" />
        </div>
      </StyledFlex>
    </Card>;
};